import { Component, input, booleanAttribute } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "app-back-button",
  imports: [],
  templateUrl: "./back-button.component.html",
  styleUrl: "./back-button.component.scss",
})
export class BackButtonComponent {
  constructor(
    private location: Location,
    private router: Router
  ) {}

  isMobileScreen = input(false, { transform: booleanAttribute });
  visibleOnDesktop = input(true, { transform: booleanAttribute });

  // Text to show when on mobile
  mobileText = input("");

  // Route to use when on mobile (overrides default back behavior)
  mobileRoute = input("");

  goBack(): void {
    // Use mobile route if on mobile screen AND mobile route is provided
    if (this.isMobileScreen() && this.mobileRoute()) {
      this.router.navigateByUrl(this.mobileRoute());
      return;
    }

    // Logic for desktop OR mobile without specific route
    const referrer = document.referrer;
    const hasSafeReferrer = referrer && new URL(referrer).origin === window.location.origin;

    if (hasSafeReferrer) {
      this.location.back();
    } else {
      this.router.navigateByUrl("/");
    }
  }

  // Determine if button should be visible
  shouldShow(): boolean {
    if (this.isMobileScreen()) {
      // On mobile: always show (control visibility via parent)
      return true;
    } else {
      // On desktop: only show if allowed
      return this.visibleOnDesktop();
    }
  }

  // Get the button text to display
  getButtonText(): string {
    // Show mobile text only when on mobile AND text is provided
    if (this.isMobileScreen() && this.mobileText()) {
      return this.mobileText();
    }
    return ""; // Desktop or no text: icon only
  }
}
